<template>
<div class="welcomeMessage">
  <b-container class="h=100">
    <b-row class="justify-content-center align-items-center h-100">
      <b-col cols="10" md="8" xl="6" class="my-5">
        <b-card v-if="success !== false"
                header="AEID Email Verification"
                title="Email Verified"
                :sub-title="email"
                header-bg-variant="success"
                border-variant="success"
                header-variant="success"
                header-text-variant="white"
                class="shadow">
            <hr class="w-25 " align="left" />
            <p class="mt-4">
              <i>Thanks!</i>
              <br/>
              By verifying your email address you can continue to access our
              earthing software, such as:
              <app-list />
            </p>
        </b-card>

        <b-card v-else
                header="AEID Email Verification"
                title="Well, that was unexpected..."
                border-variant="primary"
                header-border-variant="primary"
                header-bg-variant="info"
                class="shadow">
          <p>
            Typically, you only get to this page after you verify the email address
            you're using with AEID.
          </p>
          <p>
            If you were trying to verify your email address then there may have
            been a problem with the process (unlikely to be your fault). Try
            signing-in to your account again to see if your address has been verified,
            or contact us for support.
          </p>
          <p>
            On the other hand, if you've found your way here via some other means,
            <i>congratulations for your ingenuity</i>, but our freely available
            earthing software might be more interesting:
            <app-list />
          </p>
          <div v-if="message" class="text-muted" >
            <hr />
            The message from the authentication server was: <br />
            <div class="border text-monospace text-muted bg-light p-2">{{ message }}</div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import AppList from '@/components/AppList.vue'

export default {
  name: 'EmailVerified',
  components: {
    AppList
  },
  data () {
    return {
    //   emailAddress: {
    //     default: 'Unknown',
    //     type: String
    //   }
    }
  },
  props: {
    email: {
      default: 'Unknown',
      type: String
    },
    message: {
      default: null,
      type: String
    },
    success: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>
